export default [
    {
        id: 'basket-star',
        title: 'Basket Star',
        image: '/assets/images/balsam/bpBasketStarT.jpg',
        category: 'Balsam Pillows',
        details: <div>
           Pieced of all artist-dyed cotton cloth, and filled with the needles of the balsam fir tree. The delicious aroma will last for years! 
        </div>,
        variations: [
            {
                title: 'Basket Star',
                image: '/assets/images/balsam/bpBasketStar.jpg'
            }
        ]
    },
    {
        id: 'skinny-twirler',
        title: 'Skinny Twirler',
        image: '/assets/images/balsam/bpSkinnyTwirlerT.jpg',
        category: 'Balsam Pillows',
        details: <div>
            Pieced of all artist-dyed cotton cloth, and filled with the needles of the balsam fir tree. The delicious aroma will last for years! 
        </div>,
        variations: [
            {
                title: 'Skinny Twirler',
                image: '/assets/images/balsam/bpSkinnyTwirler.jpg'
            }
        ]
    },
    {
        id: 'spikey-star',
        title: 'Spikey Star',
        image: '/assets/images/balsam/bpSpikeyStarT.jpg',
        category: 'Balsam Pillows',
        details: <div>
            Pieced of all artist-dyed cotton cloth, and filled with the needles of the balsam fir tree. The delicious aroma will last for years! 
        </div>,
        variations: [
            {
                title: 'Spikey Star',
                image: '/assets/images/balsam/bpSpikeyStar.jpg'
            }
        ]
    },
    {
        id: 'bp-spiral',
        title: 'Spiral',
        image: '/assets/images/balsam/bpSprialT.jpg',
        category: 'Balsam Pillows',
        details: <div>
            Pieced of all artist-dyed cotton cloth, and filled with the needles of the balsam fir tree. The delicious aroma will last for years! 
        </div>,
        variations: [
            {
                title: 'Spiral',
                image: '/assets/images/balsam/bpSprial.jpg'
            }
        ]
    },
    {
        id: 'bp-square-in-square',
        title: 'Square in Square',
        image: '/assets/images/balsam/bpSquareInSquareT.jpg',
        category: 'Balsam Pillows',
        details: <div>
            Pieced of all artist-dyed cotton cloth, and filled with the needles of the balsam fir tree. The delicious aroma will last for years! 
        </div>,
        variations: [
            {
                title: 'Square in Square',
                image: '/assets/images/balsam/bpSquareInSquare.jpg'
            }
        ]
    },
    {
        id: 'tulip-star',
        title: 'Tulip Star',
        image: '/assets/images/balsam/bpTulipStarT.jpg',
        category: 'Balsam Pillows',
        details: <div>
            Pieced of all artist-dyed cotton cloth, and filled with the needles of the balsam fir tree. The delicious aroma will last for years! 
        </div>,
        variations: [
            {
                title: 'Tulip Star',
                image: '/assets/images/balsam/bpTulipStar.jpg'
            }
        ]
    }
]